import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import http from './plugins/axios';
import userInfoHelper from 'common/userInfo';
import cookies from 'js-cookie'

Vue.use(Vuex);

//eslint-disable-next-line
const debug = process.env.NODE_ENV !== 'production';
const systemId = Math.floor(Math.random() * 100 + 1)

// 福利二期菜单 Mock 已在联调阶段停用，菜单完全使用 /tenant/info 的真实 menuTree。
const state = {
  userInfo: userInfoHelper.get() || {},
};

const mutations = {
  setUserInfo(state, payload) {
    state.userInfo = payload;
    userInfoHelper.set(payload);
  },

};

const actions = {
  login({ commit }, { account, password, }) {
    return http
      .post({
        url: '/ta/admin/tenant/login',
        data: {
          account,
          password,
        }
      })
      .then((res) => {
        return res
      });
  },
  secondSuffix({ commit }, { uuid, googleCode }) {
    return http.post({
      url: '/ta/admin/tenant/login/second',
      data: {
        uuid, googleCode
      },
      // headers: {
      //   'systemId': systemId,
      // }
    }).then(res => {
      if (res.code == 0) {
        commit('setUserInfo', {})
        userInfoHelper.setUser(res.data.token)
      }
      return res
    })
  },
  logout() {
    userInfoHelper.clear()
    window.location.href = '/';
  },

  //eslint-disable-next-line
  getPhoneCode({ commit }, loginName) {
    return new Promise(resolve => {
      http
        .get({
          url: '/ta/admin/check/code',
          data: {
            loginName
          }
        })
        .then(({ data }) => {
          resolve(data);
        });
    });
  },
  getUserInfo({ commit }) {
    return http.get({
      url: '/ta/admin/tenant/info'
    }).then(res => {
      if (res.code == 0) {
        const data = { ...(res.data || {}) };
        // 联调阶段不注入福利二期 Mock 菜单。
        // if (Array.isArray(data.menuTree) && data.menuTree.length) {
        //   // data.menuTree = injectDebugFundsRebateDetailMenu(data.menuTree);
        //   data.menuTree = data.menuTree.map(item => {
        //     if (item.id === 18) {
        //       item.children.push({
        //         id: 99991801,
        //         name: '资金概览明细',
        //         pathUrl: '/home/funds/rebate-detail',
        //       });
        //     }
        //     return item;
        //   });
        // }
        userInfoHelper.set(data);
        commit('setUserInfo', data);
      }
      return res
    })
  },
};

export default new Vuex.Store({
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  state,
  mutations,
  actions
});
